<template>
  <div class="base-panel d-flex flex-column">
    <div class="panel-header flex-none" :style="headerStyle">
      <slot name="header">{{ title }}</slot>
    </div>
    <slot name="progress" />
    <div class="d-flex flex-column panel-content flex">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },

    headerStyle: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.base-panel {
  background: white;
  box-shadow: var(--default-box-shadow);
  border-radius: 0.3125em;
}

.panel-header {
  background: var(--primary);
  color: white;
  padding: 0.625em 0.9375em;
  flex: none;
  font-size: 1em;
  font-weight: bold;
  border-top-left-radius: 0.3125em;
  border-top-right-radius: 0.3125em;
}

.panel-content {
  padding: 0.625em 0.9375em;
}
</style>
